import { render, staticRenderFns } from "./Bargainlist.vue?vue&type=template&id=2b9e9eaa&scoped=true"
import script from "./Bargainlist.vue?vue&type=script&lang=js"
export * from "./Bargainlist.vue?vue&type=script&lang=js"
import style0 from "./Bargainlist.vue?vue&type=style&index=0&id=2b9e9eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e9eaa",
  null
  
)

export default component.exports